import { useState } from 'react'
import { useMessageData } from '@hooks'
import NotificationPopup from '@components/NotificationPopup/NotificationPopup'
import { GameUIMessageType } from 'game-ui-types'
import FreespinsPressStartCounter from './FreespinsPressStartCounter'
import { useFreeSpinsBonusesStore } from '@stores/freeSpinsBonusesStore'

type PressStartType = 'pressStartCounter' | 'notificationPopUp' | null

const FreespinsPressStartCounterController = () => {
    const [pressStartType, setPressStartType] = useState<PressStartType>(null)
    const [seconds, setSeconds] = useState(15)

    const setIsFreespinsPressStartCounterActive = useFreeSpinsBonusesStore(
        (state) => state.setIsFreespinsPressStartCounterActive
    )

    useMessageData(({ type, payload }) => {
        if (type === GameUIMessageType.FREESPINS_PLAY_PRESS_TO_RUN_COUNTER) {
            const pressType = payload?.freespinsPressToStartType

            setSeconds(payload?.seconds ?? 15)

            if (pressType === 'pressStartCounter') {
                setIsFreespinsPressStartCounterActive(true)
                setPressStartType('pressStartCounter')
            }

            if (pressType === 'notificationPopUp') {
                setPressStartType('notificationPopUp')
            }
        }

        if (type === GameUIMessageType.FREESPINS_SPLASH_STARTED) {
            setPressStartType(null)
        }
    }, [])

    if (pressStartType === 'pressStartCounter') {
        return <FreespinsPressStartCounter duration={seconds * 1000} />
    }

    if (pressStartType === 'notificationPopUp') {
        return <NotificationPopup shouldShow={true} duration={seconds * 1000} type="freespins-counter" />
    }

    return null
}

export default FreespinsPressStartCounterController
